import NotificationIconSVG from 'assets/icons/notification-icon.svg';
import NotifyAnimationBlueIcon from 'components/common/Icons/NotifyAnimationBlueIcon';
import NotifyAnimationLightIcon from 'components/common/Icons/NotifyAnimationLightIcon';
import NotificationIcon from 'components/common/Icons/NotifyIcon';
import {
  DESKTOP_MIN_WIDTH,
  NOTIFICATIONS_PREFIX,
  TABLET_MAX_WIDTH,
} from 'constants';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import { Navbar, Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export const NOTIFICATION_NAME = 'notification-name';

const CustomNotificationDropdownMobile = ({ isShowNavbar, setShowNavbar }) => {
  const { t } = useLang();
  const { state } = useStore();
  let { isNewNotification, notifications } = state;
  const navigate = useNavigate();
  const { isHHMTTheme } = useTheme();

  const handleOnClick = () => {
    navigate(`${NOTIFICATIONS_PREFIX}?tab=2`);
  };

  return (
    <>
      <style>
        {`
          .notification-dropdown-mobile-offcanvas {
            width: 100%!important;
            height: 100%;
            border: none!important;
          }

          @media screen and (max-width: ${TABLET_MAX_WIDTH}px) { 
            .notification-dropdown-mobile-offcanvas {
              height: calc(100% - 70px);
              margin-top: 70px;
            }
          }

          @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) { 
            .notification-dropdown-mobile-offcanvas {
              width: 375px!important;
            }
          }

          .notification-dropdown-mobile-offcanvas-backdrop {
            opacity: 0.7!important;
          }
        `}
      </style>
      <CustomNotificationDropdownStyled>
        <NavbarStyled
          expand={false}
          expanded={isShowNavbar}
          onToggle={() => {}}
        >
          <NavbarToggle
            aria-controls="offcanvasNavbar-expand-false"
            className="notification-mobile-icon"
            onClick={handleOnClick}
          >
            {!isEmpty(notifications) &&
              !isEmpty(notifications?.filter(({ read }) => !read)?.length) && (
                <>
                  {isNewNotification ? (
                    <>
                      {isHHMTTheme ? (
                        <NotifyAnimationLightIcon />
                      ) : (
                        <NotifyAnimationBlueIcon />
                      )}
                    </>
                  ) : (
                    <NotificationIcon
                      color={
                        isHHMTTheme ? 'var(--ds-c-white)' : 'var(--ds-c-blue)'
                      }
                      styles={{
                        padding: '9.5px',
                      }}
                    />
                  )}
                  <HaveNotify>
                    {notifications.filter(({ read }) => !read)?.length}
                  </HaveNotify>
                </>
              )}
          </NavbarToggle>
          <NavbarOffcanvas
            id="offcanvasNavbar-expand-false"
            aria-labelledby="offcanvasNavbarLabel-expand-false"
            placement="end"
            className="notification-dropdown-mobile-offcanvas"
            backdropClassName="notification-dropdown-mobile-offcanvas-backdrop"
          >
            <OffcanvasHeader closeButton>
              <OffcanvasTitle id="offcanvasNavbarLabel-expand-false">
                {t('label_notifications')}
              </OffcanvasTitle>
            </OffcanvasHeader>
            <OffcanvasBody></OffcanvasBody>
          </NavbarOffcanvas>
        </NavbarStyled>
      </CustomNotificationDropdownStyled>
    </>
  );
};

const CustomNotificationDropdownStyled = styled.div`
  position: relative;
`;

const NavbarStyled = styled(Navbar)`
  display: initial;
  padding: 0;
  height: 40px;
  margin-right: 8px;
`;

const NavbarToggle = styled(Navbar.Toggle)`
  padding: 0;
  border: none;

  &:focus {
    border: none;
    box-shadow: none;
  }

  .navbar-toggler-icon {
    background-image: url(${NotificationIconSVG});
    background-size: 14px;
    border-color: var(--ds-c-white);
    width: 36px;
    opacity: 1;
  }
`;

const NavbarOffcanvas = styled(Navbar.Offcanvas)``;
const OffcanvasHeader = styled(Offcanvas.Header)`
  height: 70px;
  padding: 16px 24px;
  border-bottom: 1px solid #eef2f5;

  & button {
    background-size: 14px;
    color: var(--ds-c-grey-dark);
    opacity: 1;

    &:hover {
      color: var(--ds-c-grey-hover);
    }

    &:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    height: 56px;
  }
`;
const OffcanvasTitle = styled(Offcanvas.Title)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #0e1012;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const OffcanvasBody = styled(Offcanvas.Body)`
  padding: 0px;
  padding-bottom: 50px;
`;

const HaveNotify = styled.span`
  font-family: var(--ff-primary);
  line-height: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  color: var(--ds-c-white);
  text-decoration: none;
  text-align: center;
  padding-right: 0px;

  position: absolute;
  top: -1px;
  left: 18px !important;
  width: 12px;
  height: 12px;
  background: #e72631;
  border-radius: 100%;
`;

export default CustomNotificationDropdownMobile;
